import { connect } from "react-redux";
// API
import api from "api";
// Action
import { openErrorDialog } from "redux/modules/errorDialog";
import {
  initSurveyProgress,
  setSurveyProgress,
  setLocale
} from "redux/modules/surveyProgress";

// Component
import SurveyProgress from "components/SurveyProgress";
// Utils
import history from "utils/history";
import {setEmployeeMaster} from "../../redux/modules/empolyeeMaster";

const mapStateToProps = state => {
  return { ...state,
    employeeCount: state.employeeMaster.employeeCount
  }
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  historyPush: path => history.push(path, ownProps),
  initSurveyProgress: () => {
    dispatch(initSurveyProgress());
  },
  fetchSurveyProgress: () => {
    const { id } = ownProps.match.params;
    api
      .get(`survey_progress/${id}`)
      .then(res =>
        dispatch(
          setSurveyProgress(
            res.customer,
            res.survey,
            res.surveyLocales,
            res.deptResults
          )
        )
      )
      .catch(error => dispatch(openErrorDialog(error)));

    api
      .get(`employee_count/${id}`)
      .then(res => {
        dispatch(setEmployeeMaster(res));
      })
      .catch(error => dispatch(openErrorDialog(error)));
  },
  changeLocale: (event, localeId) => dispatch(setLocale(localeId))
});

export default connect(mapStateToProps, mapDispatchToProps)(SurveyProgress);



// WEBPACK FOOTER //
// ./src/containers/SurveyProgress/SurveyProgressContainer.js